export const DeliveryStatus = {
  UnderReview: _TL_('Under review'),
  Ready: _TL_('Ready'),
  Limited: _TL_('Ready (Limited)'),
  BuildingTheAudience: _TL_('Building the audience'),
};

export const WhitelistDeliveryStatus = [
  'Ready',
  'BuildingTheAudience',
];
